import React from "react";

const IconFolder = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_folder_light"
      data-name="UI icon/folder/light"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
    >
      <path
        id="Rectangle_205_Stroke_"
        data-name="Rectangle 205 (Stroke)"
        d="M12.75,14H2.25A2.3,2.3,0,0,1,0,11.667V2.333A2.3,2.3,0,0,1,2.25,0H4.318A2.2,2.2,0,0,1,5.909.683l.841.872h6A2.3,2.3,0,0,1,15,3.889v7.778A2.3,2.3,0,0,1,12.75,14ZM2.25,1.555a.765.765,0,0,0-.75.778v9.334a.765.765,0,0,0,.75.778h10.5a.765.765,0,0,0,.75-.778V3.889a.765.765,0,0,0-.75-.778h-6a1.483,1.483,0,0,1-1.06-.455l-.841-.872a.732.732,0,0,0-.531-.228Z"
        fill={color}
      />
    </svg>
  );
};

export default IconFolder;
